if (!customElements.get('vv-hero-video')) {
  customElements.define('vv-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      // On mobile the first play can start partway in; the poster stays until the video is there.
      const start = Number(this.dataset.mobileStart) || 0;
      let started = !(start > 0 && window.matchMedia('(max-width: 989px)').matches);

      const showPoster = () => this.removeAttribute('data-playing');
      const showVideo = () => {
        if (started && !this.video.paused && !this.video.error && this.video.readyState >= 2) {
          this.setAttribute('data-playing', '');
        }
      };

      if (!started) {
        const seek = () => {
          if (this.video.duration > start) {
            this.video.addEventListener('seeked', () => { started = true; showVideo(); }, { ...options, once: true });
            this.video.currentTime = start;
          } else {
            started = true;
            showVideo();
          }
        };
        if (this.video.readyState >= 1) seek();
        else this.video.addEventListener('loadedmetadata', seek, { ...options, once: true });
      }

      this.video.addEventListener('playing', showVideo, options);
      this.video.addEventListener('error', showPoster, options);
      this.video.addEventListener('emptied', showPoster, options);
      this.video.addEventListener('pause', showPoster, options);

      // Playback may already have started before the deferred script loads.
      if (!this.video.paused && this.video.readyState >= 2) showVideo();
      this.video.muted = true;
      this.video.play().catch(showPoster);
    }

    disconnectedCallback() {
      this.events?.abort();
    }
  });
}
